module.exports = __webpack_public_path__ + "static/media/mt-ut-img-14.4ddf7ea6.png";